import Swal from 'sweetalert2';
import { NODE_ENV } from '@/config';
import store from '@/store';
import { modulesName } from '@/store';
import router from '@/router';

const showToast = (title, text, icon) =>
  Swal.fire({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 4000,
    timerProgressBar: true,
    icon,
    title,
    text,
  });

export const requestErrorHandler = (error) => {
  showToast('Error', 'No se pudo enviar la solicitud.', 'error');
  return Promise.reject(error);
};

export const responseErrorHandler = (error) => {
  if (!error.isAxiosError) return Promise.reject(error);

  // No response — network down or server unreachable
  if (!error.response) {
    if (error.code === 'ECONNABORTED') {
      showToast(
        'Tiempo de espera agotado',
        'El servidor tardó demasiado en responder. Intente nuevamente.',
        'warning'
      );
    } else {
      showToast(
        'Sin conexión',
        'No se pudo conectar con el servidor.',
        'error'
      );
    }
    return Promise.reject(error);
  }

  const { data, status } = error.response;

  if (status === 400) {
    const message = data?.title || data?.message || 'Solicitud inválida.';
    showToast('Error de validación', message, 'warning');

    if (NODE_ENV !== 'production') {
      /* eslint-disable no-console */
      console.group('400 response');
      console.log(data?.title);
      console.log(data?.errors);
      console.groupEnd();
    }
  }

  if (status === 401) {
    store.dispatch(`${modulesName.userModuleName}/logout`).then(() => {
      router.push('/signin').catch(() => {});
    });
    showToast(
      'Sesión expirada',
      'Su sesión ha expirado. Por favor inicie sesión nuevamente.',
      'warning'
    );
  }

  if (status === 403) {
    showToast(
      'Acceso denegado',
      'No tiene permisos para realizar esta acción.',
      'error'
    );
  }

  if (status === 500) {
    showToast(
      'Error del servidor',
      'Ocurrió un error interno. Por favor intente más tarde.',
      'error'
    );
  }

  return Promise.reject(error);
};
